import environment from "flow/configuration/environment";
import service from "flow/data/service";
import workspace from "flow/viewModels/workspace";
import { saveProductSelectionToSessionStorage } from "./productSelectionStorage";
import sessionStorage from "flow/wrappers/sessionStorage";
import config from "flow/config";

export async function enterSingleModuleMode(id: string, stayInPlace?: boolean) {
    const myFlow = workspace.getMyFlow();
    await service.enterSingleModuleMode(myFlow, id);

    // Store currently selected product.
    // We will attempt to restore it once single module mode ends.
    let payload = environment.get<string>(environment.keys.productPayload);

    if (payload) {
        try {
            // If present, we need to parse the payload before passing it along to avoid double JSON encoding.
            payload = JSON.parse(payload);
        } catch (_e) {
            // We still continue as this was more of a bonus behavior.
        }
    }

    sessionStorage.setItem(
        config.storageKeys.lastProduct,
        JSON.stringify({
            id: environment.get(environment.keys.productId),
            payload
        })
    );

    myFlow.refreshFlow(true, stayInPlace);
}

export async function exitSingleModuleMode(stayInPlace?: boolean) {
    const myFlow = workspace.getMyFlow();
    await service.exitSingleModuleMode(myFlow);

    // Attemp to restore previously selected product
    try {
        const lastProduct = JSON.parse(sessionStorage.getItem(config.storageKeys.lastProduct));
        sessionStorage.removeItem(config.storageKeys.lastProduct);
        saveProductSelectionToSessionStorage(lastProduct);
    } catch (_e) {
        // We failed to restore last product before single module mode.
        // It could happen if user has switched tab or something.
        // We can just ignore and let user get the product selector dialog instead.
    }

    myFlow.refreshFlow(true, stayInPlace);
}

export function isSingleModuleMode() {
    return environment.get(environment.keys.singleModule) !== null;
}
